<template>
    <div>
      <a-button :size="btnSize" v-if="!readonly" :id="'AttachButton' + _uid" icon="upload" :loading="configLoading">上传文件</a-button>
      <div v-for="(file, idx) in uploadFiles" :key="file.id" class="file_list">
        <a @click="onView(idx)">
          {{ file.name }}
          <span v-if="hasError" style="color:red">{{ file.response }}</span>
          <span class="size1 ml-3" v-else>{{ file.extension }}&nbsp;{{ file.size }}</span>
        </a>
        <div class="delete" v-if="!readonly">
          <a-popconfirm
              title="是否确认删除?" @confirm="onDelete(file.id)">
            <a-icon type="delete" style="font-size: 16px;"/>
          </a-popconfirm>
        </div>

        <div class="progress">
          <div v-show="file.percent < 100" :style="{width:file.percent + '%'}"></div>
        </div>
      </div>
    </div>
</template>

<script>
import { ACCESS_TOKEN } from '@/store/mutation-types'
import plupload from 'plupload'

export default {
  name: 'UploadSelector',
  props: {
    referId: {
      type: String,
      required: true,
      default: ''
    },
    configKey: {
      type: String,
      required: true
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    btnSize: {
      type: String,
      default: 'small'
    },
    max: {
      type: Number,
      required: false,
      default: 99
    },
    // 此字段仅用作融合到 Form 检验必须上传功能
    value: {
      type: String
    }
  },
  mounted () {
    this.loadConfig()
    this.refreshData()
  },
  computed: {
  },
  watch: {
    referId (val) {
      this.refreshData()
    }
  },
  data () {
    return {
      user: this.$ls.get('user'),
      access_token: '',
      configLoading: true,
      uploading: false,
      hasError: false,
      config: null,
      uploadFiles: [],
    }
  },
  methods: {
    loadConfig () {
      const that = this
      that.$http.get('/api/1/attachment/config.json?key=' + that.configKey).then(function (response) {
        if (response.code === 200) {
          that.configLoading = false
          that.config = response.result
          that.initUploader()
        }
      })
    },
    onView (idx) {
      let file = this.uploadFiles[idx]
      window.open(file.url)
    },
    getFileIndex (id) {
      return this.uploadFiles.findIndex(item => item.id === id)
    },
    refreshData () {
      const that = this
      if (!that.referId) {
        return
      }
      let configKey = that.configKey
      if (that.isAllCase) {
        configKey = ''
      }
      that.$http.get('/api/1/attachment/attachments.json?referId=' + that.referId + '&configKey=' + configKey).then(function (response) {
        if (response.code !== 200) {
          return
        }
        let files = []
        response.result.forEach(item => {
            let fileObj = {
              id: item.id,
              name: item.name,
              userId: item.userId,
              extension: item.extension,
              size: item.sizeDesc,
              percent: 100,
              response: null,
              clazz: 'ant-upload-list-item-done',
              url: process.env.VUE_APP_WEB_SERVER + '/api/1/attachment/download?id=' + item.id
            }

            files.push(fileObj)
        })
        that.uploadFiles = files
        if (that.uploadFiles.length > 0) {
          that.sendEvent()
        }
      })
    },
    onDelete (fileId) {
      const that = this
      that.$http.get('/api/1/attachment/delete.json?id=' + fileId).then(function (response) {
        if (response.code === 200) {
          that.uploadFiles = that.uploadFiles.filter(file => file.id !== fileId)
        }
        that.sendEvent()
      })
    },
    initUploader () {
      const that = this
      let mimeTypes = []
      let mime = that.config.extension.join(',')
      if (!mime.includes('***')) {
        // console.log('allow exts:' + mime.split('|').join(','))
        mimeTypes.push({ title: '文件类型', extensions: mime.split('|').join(',') })
      }
      const uploader = new plupload.Uploader({
        headers: { 'X-Auth-Token': that.$ls.get(ACCESS_TOKEN) },
        runtimes: 'html5,flash,html4',
        browse_button: 'AttachButton' + that._uid,
        url: that.$_c + 'api/1/attachment/plupload.json',
        flash_swf_url: '../../../static/plupload/2.3.6/Moxie.swf',
        filters: {
          mime_types: mimeTypes,
          max_file_size: (that.config.maxSize / 1024) + 'kb',
          prevent_duplicates: false
        },
        init: {
          BeforeUpload: function () {
            uploader.setOption('multipart_params', { referId: that.referId, key: that.configKey })
          },
          FilesAdded: function (up, files) {
            if (that.uploadFiles.length + files.length > that.max) {
              that.$warning({ title: '最多上传 ' + that.max + ' 个文件' })
              files.map(item => uploader.removeFile(item.id))
              return
            }
            plupload.each(files, function (file) {
              that.uploadFiles.push({
                id: file.id,
                name: file.name,
                userId: that.user.id,
                size: plupload.formatSize(file.size),
                percent: 1,
                response: null,
                clazz: 'ant-upload-list-item-uploading'
              })
            })
            that.uploading = true
            uploader.start()
          },
          UploadProgress: function (up, file) {
            const idx = that.getFileIndex(file.id)
            if (idx < 0) {
              return
            }
            that.uploadFiles[idx].percent = file.percent
          },
          FileUploaded: function (up, file, info) {
            let text = info.response
            let result = /<pre[^>]*>(.*?)<\/pre>/g.exec(info.response)
            if (result) {
              text = result[1]
            }
            let response = JSON.parse(text)
            const idx = that.getFileIndex(file.id)
            if (response.error) {
              that.hasError = true
              that.uploadFiles[idx].percent = file.percent
              that.uploadFiles[idx].response = response.error.message
              that.uploadFiles[idx].clazz = 'ant-upload-list-item-error'
              that.uploadFiles[idx].extension = file.name.split('.').pop()
            } else {
              that.uploadFiles[idx].id = response.id
              that.uploadFiles[idx].percent = file.percent
              that.uploadFiles[idx].response = null
              that.uploadFiles[idx].clazz = 'ant-upload-list-item-done'
              if (response.isExternal === 1) {
                that.uploadFiles[idx].url = response.result
              } else {
                that.uploadFiles[idx].url = process.env.VUE_APP_WEB_SERVER + '/api/1/attachment/download?id=' + response.id
              }
              that.uploadFiles[idx].extension = file.name.split('.').pop()
            }

            that.sendEvent()
          },
          UploadComplete: function (up, files) {
            that.uploading = false
          },
          Error: function (up, err) {
            that.uploading = false
            console.log(err)
            that.$message.error(err.message)
          }
        }
      })
      uploader.init()
    },
    sendEvent () {
        this.$emit('change', this.uploadFiles.length || 0)
        this.$emit('objChange', this.uploadFiles || [])
    }
  }
}
</script>

<style scoped>
.file_list {
  background: #f9f9f9;
  padding: 6px 12px;
  margin-bottom: 8px;
  display: block;
  position: relative;
  line-height: 20px;
  height: 32px;
}

.file_list:nth-last-child(1) {
  margin-bottom: 0;
}

.file_list a {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  vertical-align: top;
  float: left;
  position: absolute;
  max-width: 100%;
  padding-right: 140px;
  box-sizing: border-box;
}
.file_list a span{
  position: absolute;
  right: 0;
  width: 130px;
  margin: 0;
}

.file_list .progress {
  position: absolute;
  bottom: 0;
  width: 100%;
  left: 0;
  background: #e8e8e8
}

.file_list .progress div {
  height: 2px;
  background: #52c41a
}

.file_list .delete {
  position: absolute;
  right: 12px;
  top: 6px;
}

.file_list .delete:hover i {
  color: #ff0000;
  cursor: pointer;
}

.file_list > span {
  vertical-align: top;
}
</style>
